import useIsMobile from 'Hooks/useIsMobile'
import moment from 'moment'
import React from 'react'
import ReactModal from 'react-modal'
import { X } from 'lucide-react'
import { DataTable, cell } from 'Components/Admin/Analytics/AdminAnalyticsUI'

// Sign-in history for one user (opened from Active logins → "Who signed in").
// Same modal shell as the approval modal (19c): scrim, white card, Spectral title,
// navy-header sortable table.
function LoginEntries({uploadNew, onClose, value}) {
  const isMobile = useIsMobile();
  const entries = Array.isArray(value) ? value : [];
  const first = entries[0] || {};
  const total = entries.reduce((sum, e) => sum + (parseInt(e.loginCount) || 0), 0);

  // newest first by default; headers still sort
  const rows = [...entries]
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((e, i) => ({ ...e, _rowKey: (e.created_at || '') + i }));

  const columns = [
    {
      label: 'Date',
      width: 'minmax(0,1fr)',
      sortVal: (r) => new Date(r.created_at).getTime() || 0,
      render: (r) => (
        <div style={cell.primary}>
          {moment(r.created_at).format('MMM D, YYYY')}
          <span style={{ marginLeft: '8px', fontSize: '11.5px', color: 'rgba(20,33,61,.45)', fontWeight: 400 }}>{moment(r.created_at).format('ddd')}</span>
        </div>
      ),
    },
    {
      label: 'Sign-ins',
      width: '100px',
      right: true,
      sortVal: (r) => parseInt(r.loginCount) || 0,
      render: (r) => <span style={cell.num(parseInt(r.loginCount) || 0)}>{r.loginCount || 0}</span>,
    },
    {
      label: 'Location',
      width: 'minmax(0,1.4fr)',
      sortVal: (r) => (r.location || '').toLowerCase(),
      render: (r) => r.location
        ? <div className='truncate' style={cell.muted} title={r.location}>{r.location}</div>
        : <span style={cell.empty}>Not recorded</span>,
    },
  ];

  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30,
          backgroundColor: 'rgba(20,33,61,.45)'
        },
        content: {
            width: isMobile ? 'calc(100% - 24px)' : '640px',
            maxWidth: '100%',
            height: 'auto',
            maxHeight: 'calc(100vh - 60px)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: 0,
            border: 'none',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 20px 50px rgba(20,33,61,.25)',
        }
      }}
    >
      <div className='flex flex-col w-full font-plexsans' style={{ maxHeight: 'calc(100vh - 60px)' }}>
        {/* Header */}
        <div className='flex items-start justify-between bg-white flex-none' style={{ padding: '20px 24px 18px', borderBottom: '1px solid rgba(20,33,61,.1)', gap: '16px' }}>
          <div className='min-w-0'>
            <div style={{ font: "600 10.5px/1 'IBM Plex Mono',monospace", letterSpacing: '.1em', textTransform: 'uppercase', color: '#8a6231', marginBottom: '8px' }}>Sign-in history</div>
            <div className='truncate' style={{ font: "400 18px/1.3 'Spectral',serif", color: '#14213d' }}>{first.name || 'Unnamed user'}</div>
            {first.email && <div className='truncate' style={{ marginTop: '2px', fontSize: '12.5px', color: 'rgba(20,33,61,.5)' }}>{first.email}</div>}
          </div>
          <div className='flex items-center flex-none' style={{ gap: '10px' }}>
            <div style={{ textAlign: 'right' }}>
              <div style={{ font: "500 20px/1 'IBM Plex Mono',monospace", color: '#14213d' }}>{total}</div>
              <div style={{ marginTop: '4px', fontSize: '11px', color: 'rgba(20,33,61,.5)' }}>
                {total === 1 ? 'sign-in' : 'sign-ins'} · {entries.length} {entries.length === 1 ? 'day' : 'days'}
              </div>
            </div>
            <button
              type='button'
              onClick={onClose}
              aria-label='Close'
              className='flex items-center justify-center rounded-[5px] transition-colors hover:bg-cream'
              style={{ width: '30px', height: '30px', marginLeft: '6px', color: 'rgba(20,33,61,.5)' }}
            >
              <X size={17} strokeWidth={1.8} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className='overflow-y-auto flex-1' style={{ padding: '18px 24px 22px', maxHeight: '420px', background: '#f7f4ed' }}>
          <DataTable
            columns={columns}
            rows={rows}
            minWidth={isMobile ? 380 : 520}
            emptyText='No sign-ins recorded for this range'
          />
        </div>
      </div>
    </ReactModal>
  )
}

export default LoginEntries
